// src/pages/Home.jsx
import React from 'react';
import InteractiveDiary from '../components/InteractiveDiary/InteractiveDiary';
import styles from './Home.module.css';

export default function Home() {
  return (
    <>
      <section className={styles.diarySection}>
        <InteractiveDiary /> 
      </section>
    </>
  );
}